import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "listings",
    "listingsOut",
    "price",
    "priceOut",
    "sales",
    "salesOut",
    "payback",
    "takehome",
    "breakeven",
  ]
  static values = { subCost: Number, takeHomeRate: Number }

  connect() {
    this.update()
  }

  update() {
    const listings = parseInt(this.listingsTarget.value, 10)
    const price = parseInt(this.priceTarget.value, 10)
    const sales = parseInt(this.salesTarget.value, 10)

    this.listingsOutTarget.textContent = listings
    this.priceOutTarget.textContent = this.currency(price)
    this.salesOutTarget.textContent = sales

    const takeHome = sales * price * this.takeHomeRateValue
    this.takehomeTarget.textContent = this.currency(takeHome)

    const dailyTakeHome = takeHome / 30
    const paybackDays = dailyTakeHome > 0 ? Math.max(1, Math.round(this.subCostValue / dailyTakeHome)) : 30
    this.paybackTarget.textContent = paybackDays === 1 ? "~1 day" : `~${paybackDays} days`

    const perSaleTakeHome = price * this.takeHomeRateValue
    const salesToBreakEven = perSaleTakeHome > 0 ? this.subCostValue / perSaleTakeHome : 99
    this.breakevenTarget.textContent = salesToBreakEven < 1 ? "< 1 sale" : `${Math.ceil(salesToBreakEven)} sales`
  }

  currency(amount) {
    return `A$${Math.round(amount).toLocaleString()}`
  }
}
